import { deepMerge } from '@vista-digital/occ-domain';
import { useMemo } from 'react';
import { useOccConfig } from '../../../context';
/**
 * Returns the seating configuration.
 *
 * @remarks
 * Any seating configuration not passed as props will default to the corresponding value in `OccConfig.seating`.
 */
export const useSeatingConfig = (config) => {
    const seatingConfig = useOccConfig().seating;
    return useMemo(() => deepMerge(seatingConfig, config), [seatingConfig, config]);
};
//# sourceMappingURL=use-seating-config.js.map